var map = {
	"./arrow.svg": 685,
	"./back_24.svg": 686,
	"./camera.svg": 687,
	"./card_blue.svg": 688,
	"./check.svg": 689,
	"./close.svg": 690,
	"./colors.svg": 691,
	"./comment.svg": 692,
	"./delete_24.svg": 693,
	"./edit_24.svg": 694,
	"./event_blue.svg": 695,
	"./geo.svg": 696,
	"./geo_blue.svg": 697,
	"./globe_outline_20.svg": 698,
	"./link_blue.svg": 699,
	"./megafon.svg": 700,
	"./noicon.svg": 701,
	"./photo.svg": 702,
	"./place.svg": 703,
	"./place_outline_20.svg": 704,
	"./procent.svg": 705,
	"./qr-code.svg": 706,
	"./text_blue.svg": 707,
	"./upload.svg": 708,
	"./vk black.svg": 709,
	"./vk blue.svg": 710,
	"./vk_white.svg": 711,
	"./wifi_blue.svg": 712
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 684;